import WalletBalance from './WalletBalance'
export default WalletBalance



// WEBPACK FOOTER //
// ./src/atoms/WalletBalance/index.js